import React, { useRef, useState } from "react";
import {
  EllipsisHorizontalCircleIcon,
  XCircleIcon,
  CheckCircleIcon,
} from "@heroicons/react/24/solid";
import PopupCopyAddress from "../../PopupCopyAddress";
import { getCurrencyAndLanguageSymbol } from "../../../../constent/currencyUtils";
import Whatsapp from "../../../../assets/Icons/icons8-whatsapp (1).svg";
import InvoiceIcon from "../../../sharedComponents/InvoiceIcon";

const DetailsCartRow = ({ details, onDelete, onEdit, onDetails, pdf }) => {
  const roundToTwo = (num) => parseFloat(Number(num).toFixed(2));
  const matchedArea =
    details?.area?._id === "67dfef4a100f542a2c700c04" ? "Turkey" : "Europe";

  const [showPopup, setShowPopup] = useState(false);
  const currencySymbol = getCurrencyAndLanguageSymbol();

  const [showValue, setShowValue] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleValue = () => {
    setShowValue((prev) => !prev);
  };

  const values = [
    details.number,
    details.boxNumber,
    details.Name,
    details.phone,
    details.status,
    matchedArea,
    // details.note,
    details.isCheck,
    details.companyName,
    details.address,
    details.history ? new Date(details.history).toISOString().slice(5, 10) : "",
    roundToTwo(Number(details.totalWeight)),
    roundToTwo(Number(details.totalPackingFees)),
    roundToTwo(Number(details.totalCartPrice)),
  ];

  return (
    <tr className="text-sm text-center text-gray-800 bg-white">
      {values.map((value, index) => (
        <td key={index} className="px-2 py-2">
          {index === 3 ? (
            <span className="flex items-center justify-center gap-4 text-black test-sm">
              {details.countryCode + value}
              <a href={`tel:${details.countryCode + value}`} className="">
                <img src={Whatsapp} className="w-7" />
              </a>
            </span>
          ) : index === 100 ? (
            <>
              <div className="relative inline-block ">
                <span
                  onClick={toggleValue}
                  ref={buttonRef}
                  className="flex px-2 py-2 text-xs text-black cursor-pointer bg-custom-yellow"
                >
                  Show Info
                </span>

                {showValue && value && (
                  <div
                    className="absolute z-50 w-[500px] px-2 py-1 mt-2 text-sm bg-white border rounded shadow "
                    ref={dropdownRef}
                  >
                    {value}
                  </div>
                )}
              </div>
            </>
          ) : index === 6 ? (
            <span title={value} className="flex justify-center text-black">
              {value ? (
                <CheckCircleIcon class="h-6 w-6 text-blue-600" />
              ) : (
                <XCircleIcon class="h-6 w-6 text-red-600" />
              )}
            </span>
          ) : index === 8 ? (
            <span className="flex justify-center text-black">
              <button
                onClick={() => setShowPopup(true)}
                className="px-2 py-1 text-black rounded bg-custom-yellow"
              >
                Show
              </button>
              {showPopup && (
                <PopupCopyAddress
                  data={value}
                  onClose={() => setShowPopup(false)}
                />
              )}
            </span>
          ) : index === 9 && details.history ? (
            <div className="flex flex-col">
              <span className="text-black">
                {new Date(details.history).toISOString().slice(5, 10)}
              </span>
              <span className="text-black">
                {new Date(details.history).toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                  timeZone: "Asia/Kuwait",
                })}
              </span>
            </div>
          ) : index === 11 || index === 12 ? (
            <>
              <span className="text-black">
                {value}{" "}
                <span className="text-[9px] text-black"> {currencySymbol}</span>
              </span>
            </>
          ) : index === 10 ? (
            <>
              <span className="text-black">
                {value} <span className="text-[9px] text-black"> KG</span>
              </span>
            </>
          ) : (
            value
          )}
        </td>
      ))}
      <td className="px-2 py-2">
        <div className="flex justify-around space-x-2">
          {/* <button onClick={onDelete}>
            <TrashIcon className="w-5 h-5 text-red-600" />
          </button> */}
          <button onClick={() => window.open(`${pdf}`, "_blank")}>
            <InvoiceIcon bgColor={"black"} />
          </button>
        </div>
      </td>
      <td className="px-2 py-2">
        <div className="flex justify-around space-x-2">
          <button onClick={onDetails}>
            <EllipsisHorizontalCircleIcon className="bg-black rounded-full text-custom-yellow w-7" />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default DetailsCartRow;
